module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=(i18n.tc( "SubscriptionReplace", "Replace subscription" )))==null?'':__t)+
'</legend> ';
 if ( hasAlarmGroup ) { 
__p+=' <div><input type="radio" name="replace-option" data-input="replace-option-radio" id="change-alarmgroup" value="add:alarmgroup"> <label class="align-left" for="change-alarmgroup">'+
((__t=( i18n.tc("SubscriptionReplace", "Change alarmgroup") ))==null?'':__t)+
'</label></div><div><input type="radio" name="replace-option" data-input="replace-option-radio" id="remove-alarmgroup" value="remove:alarmgroup"> <label class="align-left" for="remove-alarmgroup">'+
((__t=( i18n.tc("SubscriptionReplace", "Remove alarmgroup") ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' ';
 if ( ! hasAlarmGroup && isTechSupport ) { 
__p+=' <div><input type="radio" name="replace-option" data-input="replace-option-radio" id="add-alarmgroup" value="add:alarmgroup"> <label class="align-left" for="add-alarmgroup">'+
((__t=( i18n.tc("SubscriptionReplace", "Add alarmgroup") ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' <div><input type="radio" name="replace-option" data-input="replace-option-radio" id="swap-subscription" value="swap:subscription"> <label class="align-left" for="swap-subscription">'+
((__t=( i18n.tc("SubscriptionReplace", "Swap subscription") ))==null?'':__t)+
'</label></div></fieldset><fieldset class="button-wrap"><button data-click="replace-cancel">'+
((__t=(i18n.tc( "SubscriptionReplace", "Cancel" )))==null?'':__t)+
'</button> <button class="primary" data-click="replace-submit">'+
((__t=(i18n.tc( "SubscriptionReplace", "Submit" )))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
